/**
 * 다이얼로그(Modal · Drawer · ConfirmDialog)는 × · 취소 버튼으로만 닫는다.
 * 딤(바깥) 클릭, 바깥 포커스 이동, ESC 로 닫히지 않게 Radix Content 에 펼쳐 넣는다.
 * 바깥으로 취급되는 드롭다운(Select 포털) 클릭에 다이얼로그가 닫히던 문제도 함께 막는다.
 */
export const closeOnlyByButtons = {
  onPointerDownOutside: (event: Event) => event.preventDefault(),
  onInteractOutside: (event: Event) => event.preventDefault(),
  onEscapeKeyDown: (event: KeyboardEvent) => event.preventDefault(),
};
